import React, { createContext, useReducer } from 'react';

interface Invoice {
  id: number;
  invoiceUrl: string;
  status: number; /// * 状态(0:审核中 1:开票完成 2:已失效 3:已冲销) */
  taxPoint: string;
}

interface InvoiceState {
  invoiceList: Invoice[];
}

type InvoiceAction = { type: 'INIT'; payload: Invoice[] };

const initialState: InvoiceState = {
  invoiceList: []
};

const invoiceReducer = (state: InvoiceState, action: InvoiceAction): InvoiceState => {
  switch (action.type) {
    case 'INIT':
      return {
        invoiceList: action.payload
      };
    default:
      return state;
  }
};

const useInvoiceListReducer = (): [InvoiceState, React.Dispatch<InvoiceAction>] => {
  const [state, dispatch] = useReducer(invoiceReducer, initialState);
  return [state, dispatch];
};

interface InvoiceContextProps {
  state: InvoiceState;
  dispatch: React.Dispatch<InvoiceAction>;
}

const InvoiceContext = createContext<InvoiceContextProps>({
  state: initialState,
  dispatch: () => {}
});

const InvoiceProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useInvoiceListReducer();

  return <InvoiceContext.Provider value={{ state, dispatch }}>{children}</InvoiceContext.Provider>;
};

export { InvoiceContext, InvoiceProvider };
